module.exports = __webpack_public_path__ + "img/2-3.07a0c062.svg";